/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import gaLogger from 'src/utils/ga-logger';

interface   HeaderBrandLogoProps {
  href?: string | false;
  altText?: string;
  onKeyPressEvent?: (evt: React.KeyboardEvent<HTMLElement>) => void;
  onClickEvent?: (evt: React.MouseEvent<HTMLElement>) => void;
  exClass?: string;
  imgSrc: string;
  title?: string;
  areaLabel?: string;
  areaLableBy?: string;
  partnerLogoAltText?: string;
  gaTracking:
    | {
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
      }
    | undefined;
  target?: '' | '_blank' | string;
  expTracking?:
  | {
      templateType: string;
      campaignUrl: string;
      referrerId: string;
    }
  | undefined;
  partnerLogo?: string, 
  url?: string;
  hidePartnerLogo?: boolean; 
}

const HeaderBrandLogo: React.FC<HeaderBrandLogoProps> = ({
  altText = 'Partner Logo',
  imgSrc = '',
  href = '/',
  exClass,
  onClickEvent = () => {},
  onKeyPressEvent = () => {},
  gaTracking,
  target = '',
  partnerLogoAltText,
}) => {
  const buttonClickEvent = (e) => {
    if (onClickEvent) {
      onClickEvent(e);
    }

    if (gaTracking) {
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel);
    }
    if (href) {
      if (target === '') {
        window.location.href = href;
      } else {
        window.open(href, target);
      }
    }
  };
  const keyPressEvent = (e) => {
    if (onKeyPressEvent && e.key === "Enter") {
      onKeyPressEvent(e);
    }

    if (gaTracking) {
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel);
    }
    if (href) {
      if (target === '') {
        window.location.href = href;
      } else {
        window.open(href, target);
      }
    }
  };

  return (
    // <div role='link' className={exClass} tabIndex={0} onClick={(e) => buttonClickEvent(e)} onKeyDown={(e) => keyPressEvent(e)}>
    //   <img alt={partnerLogoAltText} title={altText} aria-label={partnerLogoAltText} src={imgSrc} />
    // </div>
    <a role='link' aria-label={partnerLogoAltText} className={exClass} tabIndex={0} onClick={(e) => buttonClickEvent(e)} onKeyDown={(e) => keyPressEvent(e)}>
      <img alt="" src={imgSrc} />
    </a>
  );
};

export { HeaderBrandLogo, HeaderBrandLogoProps };
